/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExchangeModel { 
    /**
     * Exchange id
     */
    id?: number;
    /**
     * Date of creation
     */
    theDate: string;
    /**
     * Currency Id
     */
    currencyId: number;
    /**
     * Debit account id
     */
    debitAccountId: number;
    /**
     * Credit account id
     */
    creditAccountId: number;
    /**
     * Date rate
     */
    dateRate: string;
    /**
     * Rate type id
     */
    rateTypeId: number;
    /**
     * Rate profit
     */
    rateProfit: number;
    /**
     * Write on amount
     */
    writeOnAmount: number;
    /**
     * Write off amount
     */
    writeOffAmount: number;
    /**
     * Actual rate
     */
    actualRate: number;
    /**
     * Rate
     */
    rate: number;
    /**
     * Info
     */
    info?: string | null;
    /**
     * Internal message
     */
    internalMessage?: string | null;
    /**
     * Document number
     */
    docNumber?: number | null;
    /**
     * Special rate
     */
    bSpecialRate: boolean;
    /**
     * Reverse rate
     */
    bReverseRate: boolean;
    /**
     * Fixed write Off amount
     */
    fixedWriteOffAmount: boolean;
    /**
     * Buy currency id
     */
    buyCurrencyId: number;
}

